import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PropTypes from "prop-types";
import GraphSelector from "./GraphSelector";
import DijkvakNiveauTab from "./DijkvakNiveauTab";
import DijkvakNiveauPerMeterTab from "./DijkvakNiveauPerMeterTab";
import CompareTable from "./CompareTable";
import { BarChart, TableBar, TableChart } from "@mui/icons-material";
import InformationDialogue from "../../../CustomComponents/InformationDialogue";
import { compare } from "../../../../context/designPhase";
import StepperButtons from "../../StepperButtons";

const tabProps = {
  sx: {pb: 0},
  iconPosition: 'start',
}

const iconProps = {
  fontSize: "small",
  sx: {mb:0, pb: 0},
}


// Tab panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`compare-tabpanel-${index}`}
      aria-labelledby={`compare-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// Tab component
function a11yProps(index) {
  return {
    id: `compare-tab-${index}`,
    "aria-controls": `compare-tabpanel-${index}`,
  };
}

export default function CompareTabs({ payload }) {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <InformationDialogue text={compare} />


        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="compare tabs"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "bold",
              fontSize: "1rem",
            },
          }}
        >
          <Tab {...tabProps} icon={<BarChart {...iconProps} />} label="Ontwerpniveau" {...a11yProps(0)} />
          <Tab {...tabProps} icon={<BarChart {...iconProps} />} label="Dijkvakniveau" {...a11yProps(1)} />
          <Tab {...tabProps} icon={<BarChart {...iconProps} />} label="Dijkvakniveau per meter" {...a11yProps(2)} />
          <Tab {...tabProps} icon={<TableChart {...iconProps} />} label="Overzichtstabel" {...a11yProps(3)} />
        </Tabs>
      </Box>
      
      <TabPanel value={tabValue} index={0}>
        <GraphSelector payload={payload} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={1}>
        <DijkvakNiveauTab payload={payload} />
      </TabPanel>
      
      <TabPanel value={tabValue} index={2}>
        <DijkvakNiveauPerMeterTab payload={payload} />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <CompareTable designs={payload.loop.designs} referenceDesign={payload.loop.reference_design} payload={payload} />
      </TabPanel>

      <StepperButtons payload={payload} updateStatus={false} />

    </Box>
  );
}

CompareTabs.propTypes = {
  payload: PropTypes.object.isRequired,
};
